import React from 'react';
import { Link } from 'react-router-dom';
import { usePageSeo } from '../hooks/usePageSeo';

interface Props {
  darkMode: boolean;
}

const ApiDocsPage: React.FC<Props> = ({ darkMode }) => {
  usePageSeo({
    title: 'Kitapçık API Dokümantasyonu',
    description: 'Salt okunur forum istatistik API, RSS ve JSON beslemeleri.',
    keywords: 'forum api, rss, json feed, embed',
    canonical: '/api-docs',
  });

  const pre = darkMode ? 'bg-gray-800 text-green-300' : 'bg-gray-100 text-gray-800';
  const text = darkMode ? 'text-gray-300' : 'text-gray-600';
  const heading = darkMode ? 'text-white' : 'text-gray-900';

  return (
    <div className={`min-h-screen ${darkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
      <div className="container mx-auto px-4 py-8 max-w-3xl">
        <h1 className={`text-3xl font-bold ${heading}`}>API ve beslemeler</h1>
        <p className={`mt-2 ${text}`}>
          Forum listelerini sitenize veya okuyucunuza bağlamak için aşağıdaki uç noktaları kullanabilirsiniz.
        </p>

        <section className="mt-8">
          <h2 className={`text-xl font-semibold ${heading}`}>Forum istatistikleri</h2>
          <pre className={`p-4 rounded-lg overflow-x-auto text-sm mt-3 ${pre}`}>
            GET https://kitapcik.net/forum-stats-api.php?forum_id=SLUG{'\n'}
            GET https://kitapcik.net/forum-stats-api.php?action=list&limit=50
          </pre>
        </section>

        <section className="mt-8">
          <h2 className={`text-xl font-semibold ${heading}`}>RSS 2.0</h2>
          <p className={`text-sm mt-2 ${text}`}>
            <strong>rising</strong> — önceki aya göre üye artışı olan forumlar (en yüksekten düşüğe).
          </p>
          <pre className={`p-4 rounded-lg overflow-x-auto text-sm mt-3 ${pre}`}>
            GET https://kitapcik.net/feed.php?type=rising{'\n'}
            GET https://kitapcik.net/feed.php?type=new{'\n'}
            GET https://kitapcik.net/feed.php?type=all
          </pre>
        </section>

        <section className="mt-8">
          <h2 className={`text-xl font-semibold ${heading}`}>JSON feed</h2>
          <p className={`text-sm mt-2 ${text}`}>Aynı türler; programatik entegrasyon için.</p>
          <pre className={`p-4 rounded-lg overflow-x-auto text-sm mt-3 ${pre}`}>
            GET https://kitapcik.net/feed.json.php?type=rising{'\n'}
            GET https://kitapcik.net/feed.json.php?type=new{'\n'}
            GET https://kitapcik.net/feed.json.php?type=all
          </pre>
          <p className={`text-xs mt-2 ${text}`}>
            Örnek alanlar: <code>items[].name</code>, <code>url</code>, <code>member_growth_percent</code> (rising).
          </p>
        </section>

        <section className="mt-8">
          <h2 className={`text-xl font-semibold ${heading}`}>Open Graph görselleri</h2>
          <p className={`text-sm mt-2 ${text}`}>
            Paylaşım önizlemeleri için dinamik PNG (lig, karşılaştırma, özet sayfaları).
          </p>
          <pre className={`p-4 rounded-lg overflow-x-auto text-sm mt-3 ${pre}`}>
            GET https://kitapcik.net/og-image.php?title=Forum+Ligi&line1=...
          </pre>
        </section>

        <section className="mt-8">
          <h2 className={`text-xl font-semibold ${heading}`}>Embed</h2>
          <p className={text}>
            <code>/embed/SLUG?theme=dark&accent=%236366f1</code> — white-label parametreleri.
          </p>
          <Link to="/embed-docs" className="text-indigo-500 hover:underline text-sm mt-2 inline-block">
            Embed dokümantasyonu →
          </Link>
        </section>

        <section className="mt-8">
          <h2 className={`text-xl font-semibold ${heading}`}>Bot önizleme</h2>
          <pre className={`p-4 rounded-lg text-sm mt-3 ${pre}`}>
            GET https://kitapcik.net/prerender-forum.php?forum_id=SLUG
          </pre>
        </section>

        <p className={`mt-10 text-sm ${text}`}>
          <Link to="/sponsor" className="text-indigo-500 hover:underline">
            Sponsorlu listeleme
          </Link>
        </p>
      </div>
    </div>
  );
};

export default ApiDocsPage;
